export const SIDEBAR_ICON_LINE_WEIGHT = 1.2;
export const SIDEBAR_ICON_GRID = 18;

export const sidebarIconStrokeWidth = (renderPx: number) =>
  (SIDEBAR_ICON_LINE_WEIGHT * SIDEBAR_ICON_GRID) / renderPx;
